import { endpointService } from "../../messaging/services/endpointService";
import { crmSetupConfigurationService } from "./crmSetupConfigurationService";

export interface DisconnectMetaOnFluxZapExtensionDeactivatedParams {
  organizationId?: string;
}

export async function hasActiveMetaWhatsAppConnection(
  params: DisconnectMetaOnFluxZapExtensionDeactivatedParams,
): Promise<boolean> {
  const organizationId = params.organizationId?.trim();
  if (!organizationId) return false;

  const endpoint = await endpointService.getActiveWhatsAppEndpointByContext({
    organizationId,
  });

  return Boolean(endpoint?.id && endpoint.status === "active");
}

export async function disconnectMetaOnFluxZapExtensionDeactivated(
  params: DisconnectMetaOnFluxZapExtensionDeactivatedParams,
): Promise<boolean> {
  const organizationId = params.organizationId?.trim();
  if (!organizationId) return false;

  if (!(await hasActiveMetaWhatsAppConnection({ organizationId }))) {
    return false;
  }

  await crmSetupConfigurationService.clearMetaConnection({ organizationId });
  return true;
}
